import { dateShortString } from "utils/date-format";
import { getFrequencyText } from "models/subscription";
import capitalize from "lodash/capitalize";

function SubscriptionListItem({ subscription }) {
	const { wineClub, status } = subscription;

	return (
		<tr>
			<td>{dateShortString(subscription.createdAt)}</td>
			<td>{wineClub.name}</td>
			<td className="justify-end">{wineClub.bottles}</td>
			<td>{getFrequencyText(wineClub.frequency)}</td>
			<td>-</td>
			<td>-</td>
			<td>{capitalize(status)}</td>
			<td></td>
		</tr>
	);
}
export default SubscriptionListItem;
